import React from 'react';

import { Flex } from '@chakra-ui/react';
import { getUserL2Access } from 'Deer/helpers/getUserAccess';
import { useAllCompetencySummaryReviewFormData } from 'screens/performanceReview/components/CompetencyForm/hooks/dataHooks';

import { isMobileView } from 'constants/isMobileView';

import { ProgressBar } from 'uiToolkitV1/ProgressBar';
import { TextLabelSmall } from 'uiToolkitV1/Typography';
import ViewMore from 'uiToolkitV1/ViewMore/ViewMore';

const CompetencySummary = ({ competencyId }) => {
  const { data, isLoading } = useAllCompetencySummaryReviewFormData({
    competencyId,
  });

  const allCompetencies = data?.competencies ?? [];

  const currentCompetency =
    // eslint-disable-next-line eqeqeq
    allCompetencies.find(({ competencyId: id }) => competencyId == id) ?? {};

  const { description = '', progressPercentage = '', progressDetails } = currentCompetency;

  const { displayScore, maxScore } = progressDetails ?? {};

  if (isLoading) {
    return null;
  }

  return (
    <Flex bg="#F5F7F9" p="16px" flexDir="column">
      <div style={{ marginTop: '16px' }}>
        <ViewMore text={description || ''} min={180} max={250} ideal={200} />
      </div>
      {getUserL2Access().hasIDPAccess && (
        <div style={{ marginTop: '28px', width: isMobileView() ? '10rem' : '20rem' }}>
          <Flex flexDir="column" gap={1} w="100%">
            {/* @ts-expect-error ProgressBar expects more props */}
            <ProgressBar
              size="large"
              color="#DBF2D3"
              backgroundColor="#CFD7DF"
              value={displayScore}
              max={maxScore}
              height="24px"
            />
            <Flex justifyContent="space-between">
              <TextLabelSmall color="text.g2">0</TextLabelSmall>
              <TextLabelSmall color="text.g2">{maxScore}</TextLabelSmall>
            </Flex>
          </Flex>
        </div>
      )}
    </Flex>
  );
};

export default CompetencySummary;
